import React, {Component} from 'react';
import {  Navbar, Nav, Button } from 'react-bootstrap';
import logo from '../assets/logo.svg';

class AppHeader extends Component {
  render() {
    return (
        <Navbar expand="lg" className="le-navbar"  variant="dark" collapseOnSelect >
          <Navbar.Brand href="/">
            <img src={logo} alt="logo" className="le-logo"/>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="col-lg-10 justify-content-center">
              <Nav.Link href="/gallery">GALLERY</Nav.Link>
              <Nav.Link href="/blog">BLOG</Nav.Link>
              <Nav.Link href="/about-us">ABOUT US</Nav.Link>
            </Nav>
            <Nav className="col-lg-2">
              <a href="/contact-us">
                <Button variant="secondary" className="le-btn-off-white le-btn" size="sm">Get in touch</Button>
              </a>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
    )
  }
}

export default AppHeader;